// extracted by mini-css-extract-plugin
module.exports = {"xt-btntxt":"BtnTxt_xt-btntxt__prUt7","xtBtntxt":"BtnTxt_xt-btntxt__prUt7"};